<cerrix-workspace
    [tabID]="tabID"
    [cerrixTab]="tab"
    [data]="data"
    [headerLookup]="headerLookup"
    [module]="'Asset'"
    [moduleType]="moduleType"
    [idProp]="'guid'"
    [permissions]="permissions"
    (onDblClick)="open($event)"
    (onAddClick)="add()"
    [NumberProperties]="numberProps"
    [DateProperties]="dateProps"
>
</cerrix-workspace>
